export const sortOptionsConfig = [{
  value: 'relevance',
  label: 'Relevance'
}, {
  value: 'topRated',
  label: 'Top rated'
}, {
  value: 'trending',
  label: 'Popularity'
}, {
  value: 'topSelling',
  label: 'Top selling'
}, {
  value: 'newest',
  label: 'Newest'
}];